import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import FilterField from '../filter-field/filter-field';

import {
	setFilterIsOpen,
	setFilterLanguage,
	setOpenCategories,
	setSelectedCategories,
	setSelectedTopics,
} from '../../../../store/actions/filter';

import {
	getFilterIsOpen,
	getFilterLanguage,
	getOpenCategories,
	getSelectedCategories,
	getSelectedTopics,
} from '../../../../store/selectors/filter';

import './filter-panel.scss';

class FilterPanel extends Component {
	constructor(props) {
		super(props);

		this.clearCategory = this.clearCategory.bind(this);
		this.selectTopic = this.selectTopic.bind(this);
		this.toggleLanguage = this.toggleLanguage.bind(this);
		this.selectedCategory = this.selectedCategory.bind(this);
		this.toggleTopics = this.toggleTopics.bind(this);
		this.toggleSection = this.toggleSection.bind(this);
		this.renderTopic = this.renderTopic.bind(this);
		this.renderCategory = this.renderCategory.bind(this);
		this.renderLanguage = this.renderLanguage.bind(this);
	}

	clearCategory(categoryId) {
		const { section, selectedTopics, dispatch } = this.props;
		const { topics } = section.categories.find((category) => {
			return category.id === categoryId;
		});

		const updatedTopics = [].concat([], selectedTopics);

		Array.from(topics).forEach((topic) => {
			if (updatedTopics.includes(topic.id)) {
				updatedTopics.splice(updatedTopics.indexOf(topic.id), 1);
			}
		});

		dispatch(setSelectedTopics(updatedTopics, section.id));
	}

	selectTopic(event) {
		const { id: topicId } = event.currentTarget;
		const { section, selectedTopics, dispatch } = this.props;
		const topics = [].concat([], selectedTopics);

		if (!event.currentTarget.checked) {
			topics.splice(topics.indexOf(topicId), 1);
		} else {
			topics.push(topicId);
		}

		dispatch(setSelectedTopics(topics, section.id));
	}

	toggleLanguage(event) {
		const { value: languageCode } = event.currentTarget;
		const { section, dispatch } = this.props;

		dispatch(setFilterLanguage(languageCode, section.id));
	}

	toggleTopics(event) {
		const { categoryId } = event.currentTarget.dataset;
		const { section, openCategories, dispatch } = this.props;
		const newOpenCategories = [...openCategories];

		if (newOpenCategories.indexOf(categoryId) !== -1) {
			newOpenCategories.splice(newOpenCategories.indexOf(categoryId), 1);
		} else {
			newOpenCategories.push(categoryId);
		}

		dispatch(setOpenCategories(newOpenCategories, section.id));
	}

	selectedCategory(event, topics) {
		const { id: categoryId } = event.currentTarget;
		const {
			section,
			selectedCategories,
			selectedTopics,
			openCategories,
			dispatch,
		} = this.props;
		const newSelectedCategories = [...selectedCategories];
		const newSelectedTopics = [...selectedTopics];
		const newOpenCategories = [...openCategories];

		if (!event.currentTarget.checked) {
			newSelectedCategories.splice(newSelectedCategories.indexOf(categoryId), 1);
		} else {
			newSelectedCategories.push(categoryId);
			topics.forEach((topic) => {
				newSelectedTopics.push(topic.id);
			});
			newOpenCategories.push(categoryId);

			dispatch(setSelectedTopics(newSelectedTopics, section.id));
			dispatch(setOpenCategories(newOpenCategories, section.id));
		}

		dispatch(setSelectedCategories(newSelectedCategories, section.id));
	}

	toggleSection() {
		const { section, isOpen, dispatch } = this.props;

		dispatch(setFilterIsOpen(!isOpen, section.id));
	}

	renderTopic(topic) {
		const { selectedTopics } = this.props;

		return (
			<li key={topic.id} className="C3-filter__panel__topic-item">
				<FilterField
					id={topic.id}
					type="checkbox"
					label={`${topic.title}&nbsp;(${topic.results})`}
					checked={selectedTopics.includes(topic.id)}
					onChange={this.selectTopic}
				/>
			</li>
		);
	}

	renderCategory(category) {
		const { openCategories, selectedCategories } = this.props;
		let categoryClass = 'C3-filter__panel__category-item';

		if (openCategories.includes(category.id)) {
			categoryClass += ' is-open';
		}

		return (
			<li key={category.id} className={categoryClass}>
				<FilterField
					id={category.id}
					type="checkbox"
					label={`${category.title}&nbsp;(${category.results})`}
					checked={selectedCategories.includes(category.id)}
					onChange={(event) => {
						this.selectedCategory(event, category.topics);
					}}
				/>
				{category.topics.length > 0 ? (
					<React.Fragment>
						<span className="C3-filter__panel__topic-toggle" role="presentation" onClick={this.toggleTopics} data-category-id={category.id} />
						<ul className="C3-filter__panel__topic-list">
							{category.topics.map(this.renderTopic)}
						</ul>
					</React.Fragment>
				) : null }
			</li>
		);
	}

	renderLanguage(language) {
		const { defaultLanguage } = this.props;
		let { currentLanguage } = this.props;

		if (!currentLanguage) {
			currentLanguage = defaultLanguage;
		}

		return (
			<li key={language.id} className="C3-filter__panel__category-item">
				<FilterField
					id={language.id}
					type="radio"
					label={`${language.title}&nbsp;(${language.results})`}
					value={language.code}
					checked={language.code === currentLanguage}
					onChange={this.toggleLanguage}
				/>
			</li>
		);
	}

	render() {
		const { section, isOpen } = this.props;
		let sectionClass = 'C3-filter__panel';

		if (isOpen) {
			sectionClass += ' is-open';
		}

		return (
			<div className={sectionClass}>
				<span className="C3-filter__panel__section-title" role="presentation" onClick={this.toggleSection}>{section.title}</span>
				<ul className="C3-filter__panel__category-list">
					{section.type === 'standardFilter' ? section.categories.map(this.renderCategory) : null}
					{/* {section.type === 'languageFilter' ? section.languages.map(this.renderLanguage) : null} */}
				</ul>
			</div>
		);
	}
}

FilterPanel.defaultProps = {
	isOpen: false,
	section: {},
	currentLanguage: '',
	defaultLanguage: 'en_US',
	selectedTopics: [],
	openCategories: [],
	selectedCategories: [],
	dispatch: () => {},
};

FilterPanel.propTypes = {
	isOpen: PropTypes.bool,
	section: PropTypes.shape({}),
	currentLanguage: PropTypes.string,
	defaultLanguage: PropTypes.string,
	selectedTopics: PropTypes.arrayOf(PropTypes.string),
	openCategories: PropTypes.arrayOf(PropTypes.string),
	selectedCategories: PropTypes.arrayOf(PropTypes.string),
	dispatch: PropTypes.func,
};

const mapStateToProps = (state, props) => {
	const { section } = props;

	return {
		isOpen: getFilterIsOpen(state.filter, section.id),
		currentLanguage: getFilterLanguage(state.filter, section.id) || '',
		selectedTopics: getSelectedTopics(state.filter, section.id),
		openCategories: getOpenCategories(state.filter, section.id),
		selectedCategories: getSelectedCategories(state.filter, section.id),
	};
};

export default connect(mapStateToProps)(FilterPanel);
